import { Box, Button, Typography, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

import Tick from 'assets/icons/blue-tick.svg';

export const ModalContent = styled(Box)({
	...flexMixin({ justify: 'flex-start', direction: 'column', gap: 32 }),
	width: '100%',
	margin: '48px',
	boxSizing: 'border-box',
});

export const ModalInfo = styled(Box)({
	...flexMixin({ direction: 'column', gap: 5 }),
	textAlign: 'center',

	'& h4': {
		fontSize: '24px',
		fontWeight: '700',
		lineHeight: '133.4%',
		letterSpacing: '0px',
		color: 'rgb(16, 33, 66)',
	},

	'& p': {
		fontSize: '14px',
		fontWeight: '400',
		lineHeight: '143%',
		letterSpacing: '0.15px',
		color: 'rgb(112, 122, 142)',
	},
});

export const Tariffs = styled(Box)({
	...flexMixin({ align: 'flex-start', gap: 24 }),
	width: '100%',
	height: '100%',
	overflowX: 'auto',
});

export const Tariff = styled(Box)({
	...flexMixin({ align: 'flex-start', justify: 'flex-start', direction: 'column' }),
	maxWidth: '250px',
	minHeight: '525px',
	width: '100%',
	height: '100%',
	borderRadius: '12px',
	background: 'rgba(236, 243, 255, 0.32)',
	padding: '24px',
	boxSizing: 'border-box',
});

export const TariffInfo = styled(Box)({
	...flexMixin({ align: 'flex-start', justify: 'flex-start', direction: 'column', gap: 12 }),
});

export const TariffTitle = styled(Typography)({
	fontSize: '16px',
	fontWeight: '700',
	lineHeight: '150%',
	letterSpacing: '0.15px',
	color: 'rgb(43, 80, 153)',
	textAlign: 'left',
});

export const TariffPrice = styled(Typography)({
	fontSize: '20px',
	fontWeight: 700,
	lineHeight: '160%',
	letterSpacing: '0.15px',
	color: 'rgb(16, 33, 66)',

	'& span': {
		fontSize: '12px',
		fontWeight: 400,
		lineHeight: '140%',
		letterSpacing: '0.4px',
		color: 'rgb(112, 122, 142)',
	},
});

export const TariffDescription = styled(Typography)({
	fontSize: '12px',
	fontWeight: '400',
	lineHeight: '140%',
	letterSpacing: '0.4px',
	color: 'rgb(112, 122, 142)',
	textAlign: 'left',
});

export const TariffOpportunities = styled(Box)({
	...flexMixin({ align: 'flex-start', justify: 'flex-start', direction: 'column', gap: 12 }),
	overflowY: 'auto',
	maxHeight: '260px',
	height: '100%',
});

export const TariffOpportunity = styled(Box)({
	...flexMixin({ justify: 'flex-start', gap: 8 }),
	color: 'rgb(16, 33, 66)',
	fontSize: '12px',
	fontWeight: ' 400',
	lineHeight: '140%',
	letterSpacing: '0.4px',

	'& svg': {
		height: '16px',
		width: '16px',
	},

	'&::before': {
		content: `url(${Tick})`,
		width: '16px',
		height: '16px',
	},
});

export const TariffLine = styled(Box)({
	height: '1px',
	background: 'rgb(218, 231, 255)',
	width: '100%',
	margin: '16px 0',
});

export const TariffButton = styled(Button)({
	borderRadius: '8px',
	background: 'rgb(71, 134, 255)',
	padding: '10px 16px',
	margin: 'auto 0 0 0',
	width: '100%',

	fontSize: '16px',
	fontWeight: '700',
	lineHeight: '157%',
	letterSpacing: '0.1px',
	color: 'rgb(255, 255, 255)',
	textTransform: 'none',

	'&.Mui-disabled': {
		background: 'rgb(108, 158, 255)',
		opacity: 0.6,
		color: 'rgb(255, 255, 255)',
	},

	'&:hover': {
		background: 'rgb(108, 158, 255)',
	},
});

export const LoaderBox = styled(Box)({
	...flexMixin({}),
	width: '100%',
	height: '525px',
});
